module.exports = require("./es-CL.js");